import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import {
  doGetTiers,
  doGetTier,
  doCreateTier,
  doUpdateTier,
  doDeleteTier
} from "./thunks";

const tiersAdapter = createEntityAdapter({
  selectId: (tier) => tier.id
});

const initialState = tiersAdapter.getInitialState({
  currentTier: null,
  status: "idle",
  error: null
});

const tierSlice = createSlice({
  name: "tiers",
  initialState,
  reducers: {
    clearCurrentTier: (state) => {
      state.currentTier = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Get all tiers
      .addCase(doGetTiers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(doGetTiers.fulfilled, (state, action) => {
        state.status = "succeeded";
        tiersAdapter.setAll(state, action.payload.data);
      })
      .addCase(doGetTiers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Get single tier
      .addCase(doGetTier.pending, (state) => {
        state.status = "loading";
      })
      .addCase(doGetTier.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.currentTier = action.payload.data;
      })
      .addCase(doGetTier.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Create tier
      .addCase(doCreateTier.fulfilled, (state, action) => {
        tiersAdapter.addOne(state, action.payload.data);
      })
      // Update tier
      .addCase(doUpdateTier.fulfilled, (state, action) => {
        tiersAdapter.upsertOne(state, action.payload.data);
        if (state.currentTier?.id === action.payload.data.id) {
          state.currentTier = action.payload.data;
        }
      })
      // Delete tier
      .addCase(doDeleteTier.fulfilled, (state, action) => {
        tiersAdapter.removeOne(state, action.payload.id);
      });
  }
});

export const { clearCurrentTier } = tierSlice.actions;

export const {
  selectAll: selectAllTiers,
  selectById: selectTierById,
  selectIds: selectTierIds
} = tiersAdapter.getSelectors((state) => state.tiers);

export const selectCurrentTier = (state) => state.tiers.currentTier;
export const selectTiersStatus = (state) => state.tiers.status;

export default tierSlice.reducer;
